/**
 * Converts JS Error to string representation
 * for BI
 */
export const errorToString = (error: Error): string | null => {
  if (!error || !(error instanceof Error)) {
    return null;
  }
  let msg = '';
  msg += error.toString();
  if (error.stack) {
    msg += '\n' + error.stack;
  }
  return msg;
};
